import React from 'react';
import EnhancedAnalyticsDashboard from '../analytics/EnhancedAnalyticsDashboard';

export const OpsHeadDashboard: React.FC = () => {
  // Use default date range (last 30 days)
  const dateRange = { days: 30 };

  return (
    <EnhancedAnalyticsDashboard
      dateRange={dateRange}
    />
  );
};

export default OpsHeadDashboard;